export const ConnectAccountDue: Record<string, string> = {
  business_type: "Tipo de Negócio",
  external_account: "Conta Bancária",
  "individual.verification.document": "Documento de Verificação Individual",
  "representative.address.city": "Cidade do Endereço do Representante",
  "representative.address.line1": "Linha 1 do Endereço do Representante",
  "representative.address.postal_code":
    "Código Postal do Endereço do Representante",
  "representative.address.state": "Estado do Endereço do Representante",
  "representative.dob.day": "Dia de Nascimento do Representante",
  "representative.dob.month": "Mês de Nascimento do Representante",
  "representative.dob.year": "Ano de Nascimento do Representante",
  "representative.email": "Email do Representante",
  "representative.first_name": "Primeiro Nome do Representante",
  "representative.id_number": "Número de Identificação do Representante",
  "representative.last_name": "Sobrenome do Representante",
  "representative.phone": "Telefone do Representante",
  "representative.political_exposure": "Exposição Política do Representante",
  "representative.verification.document":
    "Documento de Verificação do Representante",
  "tos_acceptance.date": "Data de Aceite dos Termos de Serviço",
  "tos_acceptance.ip": "Aceite dos Termos de Serviço",
};
